import { Fragment } from "react";

import { Separator } from "@jti/core-components/components/Separator";

import type { SummaryItem } from "@checkout-v2/features/ItemsSummary/ItemsSummaryView/ItemsSummaryView";

import { BundleLineItem } from "../BundleLineItem";
import { ProductLineItem } from "../ProductLineItem/ProductLineItem";

import styles from "./PaymentSummaryItemsList.module.scss";

type PaymentSummaryItemsListProps = {
  summaryItems: SummaryItem[];
};

export const PaymentSummaryItemsList = ({ summaryItems }: PaymentSummaryItemsListProps) => {
  return (
    <>
      {summaryItems.map((item, index) => (
        <Fragment key={item.id}>
          {item.type === "product" && <ProductLineItem {...item.item} />}
          {item.type === "bundle" && <BundleLineItem {...item.item} />}
          {index < summaryItems.length - 1 && (
            <div className={styles.separator}>
              <Separator />
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
};
